import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, Link, Switch } from 'react-router-dom';
import Post from './Post';
import FirstNews from './FirstNews';

const Profil = () =>{
    const [posts, setPosts] = useState([]);
    const [firstNews, setFirstNews] = useState(null);
    

  useEffect(() => {
    const fetchPosts = async () => {
      //const response = await fetch('/posts/posts.json');
      //const postList = await response.json();
      /*const postList = [
        { id: 'post1', title: 'My First Blog Post' },
        { id: 'post2', title: 'My Second Blog Post' },
        { id: 'post3', title: 'My Third Blog Post' }
      ];*/
      const API_BASE = process.env.REACT_APP_API_BASE;
       const response = await fetch(
            `${API_BASE}/news.php?action=list`
        );
        const postList = await response.json();
      setPosts(postList.data);
    };

    fetchPosts();

    
  }, []);


    return(
        <div>
            <div class="ttm-page-title-row">
            <div class="ttm-page-title-row-inner  ttm-bgcolor-darkgrey">
                <div class="container">
                    <div class="row align-items-center">
                        <div class="col-lg-12" style={{textAlign:'left'}}>
                            <div class="page-title-heading">
                                <h2 class="title">Profil Biro Perencanaan, Keuangan, dan Umum</h2>
                            </div>
                            <div class="breadcrumb-wrapper">
                                <span><a class="pathway" href="/">Home</a></span><span><a class="pathway" href="/profil"> Profil</a></span>                              
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="site-main">
           
            <div class="ttm-row sidebar ttm-sidebar-right ttm-bgcolor-white clearfix">
                <div class="container">
                   
                    <div class="row">
                        <div class="col-xl-9 col-lg-8 content-area" style={{textAlign:'left'}}>
                          <article class="post ttm-blog-single clearfix">
   
                            <div class="ttm-blog-single-content">
                                <div class="ttm-post-entry-header">
                                    <div class="post-meta">
                                        <span class="ttm-meta-line tags-links">
                                            Diperbaharui pada : 21 Agustus 2025</span>
                                    </div>
                                </div>
                                <div class="entry-content mt-10">
                                    <div class="ttm-box-desc-text">
                                        <h4>BIRO PERENCANAAN, KEUANGAN, DAN UMUM</h4>
                                        <p>Biro Perencanaan, Keuangan, dan Umum mempunyai tugas melaksanakan urusan perencanaan, keuangan, dan umum. Dalam melaksanakan tugas Biro Perencanaan, Keuangan, dan Umum menyelenggarakan fungsi:</p>
                                        <ul>
                                            <li>penyusunan rencana, program, dan anggaran;</li>
                                            <li>pemantauan dan evaluasi pelaksanaan program dan anggaran;</li>
                                            <li>pelaksanaan urusan keuangan;</li>
                                            <li>pelaksanaan urusan hukum;</li>
                                            <li>pelaksanaan urusan organisasi dan ketatalaksanaan;</li>
                                            <li>pelaksanaan urusan kepegawaian;</li>
                                            <li>pelaksanaan urusan ketatausahaan;</li>
                                            <li>pelaksanaan urusan kearsipan;</li>
                                            <li>pelaksanaan urusan keprotokolan;</li>
                                            <li>pelaksanaan urusan kerumahtanggaan; dan</li>
                                            <li>pengelolaan barang milik negara.</li>
                                        </ul>
                                        <h5>BAGIAN UMUM</h5>
                                        <p>Bagian Umum mempunyai tugas melaksanakan urusan ketatausahaan, keprotokolan, dan kerumahtanggaan UPN “Veteran” Yogyakarta. Bagian Umum menyelenggarakan fungsi:</p>
                                        <ul>
                                            <li>pelaksanaan urusan ketatausahaan dan dokumentasi;</li>
                                            <li>pelaksanaan urusan keprotokolan dan layanan pimpinan;</li>
                                            <li>pelaksanaan urusan kerumahtanggaan; dan</li>
                                            <li>pengelolaan sarana dan prasarana.</li>
                                        </ul>
                                        <h5>BAGIAN KEPEGAWAIAN</h5>
                                        <p>Bagian Kepegawaian menyelenggarakan fungsi penyusunan formasi dan rencana pengembangan pegawai, serta pelaksanaan urusan kepegawaian di lingkungan UPN Veteran Yogyakarta.</p>
                                        <h5>BAGIAN KEUANGAN</h5>
                                        <p>Bagian Keuangan mempunyai tugas melaksanakan urusan keuangan dan akutansi di lingkungan UPN Veteran Yogyakarta.</p>
                                        <h5>BAGIAN PERENCANAAN</h5>
                                        <p>Bagian Perencanaan mempunyai tugas menyusun, merencanakan, merancang, mengembangkan, membuat konsep, mengkaji ulang pelaksanaan perumusan kebijakan teknis penyusunan rencana, program, monitoring, evaluasi, dan pelaporan kegiatan di lingkungan UPN “Veteran” Yogyakarta.</p>
                                        <h5>A. STRUKTUR ORGANISASI BIRO PERENCANAAN, KEUANGAN, DAN UMUM</h5>
                                        <img 
                                            src="/assets/images/Gambar1.jpg" 
                                            alt="Struktur Organisasi" 
                                            style={{ width: '100%', maxWidth: '600px', height: 'auto', display: 'block', margin: '20px auto' }} 
                                        />
                                    </div>
                                </div>
                            </div>
   
                            </article>                          
                        </div>
                        <div class="col-xl-3 col-lg-4 widget-area sidebar-right ttm-col-bgcolor-yes ttm-bg ttm-right-span ttm-bgcolor-grey mt_60 pt-60 mb_60 pb-60 res-991-mt-0 res-991-pt-0">
                            <div class="ttm-col-wrapper-bg-layer ttm-bg-layer"></div>
                            <FirstNews />
                        </div>
                    </div>
                 
                </div>
            </div>
           

        </div>
    </div>
    );
};

export default Profil;